import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const NEW_PLAYER_VALUE = '__new__';

/**
 * Lets the user pick an existing player from `players`, or choose "New player"
 * and fill in a name + username instead. Reports its selection via onChange
 * as either { id } or { name, username }.
 */
export default function PlayerDropdown({ players, label, value, onChange }) {
  const [newName, setNewName] = useState('');
  const [newUsername, setNewUsername] = useState('');
  const isNew = value?.id === undefined && (newName !== '' || newUsername !== '' || value === null);

  function handleSelect(e) {
    const selected = e.target.value;
    if (selected === NEW_PLAYER_VALUE) {
      onChange({ name: newName, username: newUsername });
    } else if (selected === '') {
      onChange(null);
    } else {
      onChange({ id: selected });
    }
  }

  function handleNewNameChange(e) {
    setNewName(e.target.value);
    onChange({ name: e.target.value, username: newUsername });
  }

  function handleNewUsernameChange(e) {
    setNewUsername(e.target.value);
    onChange({ name: newName, username: e.target.value });
  }

  return (
    <div className="mb-3">
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Form.Select value={value?.id ?? (isNew ? NEW_PLAYER_VALUE : '')} onChange={handleSelect}>
          <option value="">Select a player…</option>
          {players.map(p => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
          <option value={NEW_PLAYER_VALUE}>+ New player</option>
        </Form.Select>
      </Form.Group>

      {isNew && (
        <Row className="mt-2">
          <Col>
            <Form.Control placeholder="Name" value={newName} onChange={handleNewNameChange} />
          </Col>
          <Col>
            <Form.Control placeholder="Username" value={newUsername} onChange={handleNewUsernameChange} />
          </Col>
        </Row>
      )}
    </div>
  );
}
